module.exports = __webpack_public_path__ + "ed77b8a4c1bf351c2cfcfcd467bac15b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/img/plus.svg
// module id = 1104
// module chunks = 0